import { useEffect } from 'react';

// SEO-Konfiguration pro Route – exakte Werte aus SEO-Audit
const SITE = 'https://www.livag.ch';

const seoConfig = {
  home: {
    title: 'LIVAG AG – Immobilienentwicklung & Vermittlung Ostschweiz',
    description: 'LIVAG AG: Projektentwicklung, Totalunternehmung, Sanierungen und Immobilienvermittlung in der Ostschweiz. Jetzt Erstberatung anfragen.',
    keywords: 'Immobilienentwicklung, Totalunternehmung, Projektentwicklung, Sanierungen, Immobilienvermittlung, Ostschweiz, St. Gallen',
    canonical: `${SITE}/`,
  },
  about: {
    title: 'Über LIVAG AG – Ihr Immobilienpartner in St. Gallen',
    description: 'Lernen Sie LIVAG AG kennen: Erfahrung, Werte und Team hinter Immobilienentwicklung und -vermittlung in der Ostschweiz.',
    keywords: 'LIVAG Team, Immobilienexperten St. Gallen, Christoph Jermann, Immobilienpartner Ostschweiz',
    canonical: `${SITE}/ueber-uns`,
  },
  projects: {
    title: 'Realisierte Immobilienprojekte St. Gallen & Ostschweiz | LIVAG',
    description: 'Übersicht realisierter Bau- und Entwicklungsprojekte von LIVAG AG in St. Gallen, Rorschach, Arbon und der Ostschweiz.',
    keywords: 'Immobilienprojekte St. Gallen, Mehrfamilienhaus Ostschweiz, Neubau Arbon, Sanierung Referenzen',
    canonical: `${SITE}/projekte`,
  },
  strategy: {
    title: 'Unsere Strategie – Immobilienentwicklung mit Weitblick | LIVAG',
    description: 'So arbeitet LIVAG AG: Strategie, Vorgehen und Qualitätsanspruch bei Projektentwicklung und Totalunternehmung.',
    keywords: 'Immobilienstrategie, nachhaltige Projektentwicklung, Totalunternehmung Qualität',
    canonical: `${SITE}/strategie`,
  },
  contact: {
    title: 'Kontakt – LIVAG AG St. Gallen | Immobilienberatung',
    description: 'Kontaktieren Sie LIVAG AG in St. Gallen für eine kostenlose Erstberatung zu Kauf, Verkauf oder Projektentwicklung.',
    keywords: 'Kontakt LIVAG, Immobilienberatung St. Gallen, Erstberatung Ostschweiz',
    canonical: `${SITE}/kontakt`,
  },
  blog: {
    title: 'Blog & Ratgeber – Immobilien Ostschweiz | LIVAG AG',
    description: 'Praxisnahe Artikel zu Kauf, Verkauf, Bewertung und Entwicklung von Immobilien in der Ostschweiz von LIVAG AG.',
    keywords: 'Immobilien Blog, Ratgeber Immobilien Ostschweiz',
    canonical: `${SITE}/blog`,
  },
  // Pillar-Seiten (Hauptcluster)
  immobilienVerkauf: {
    title: 'Immobilie verkaufen Ostschweiz – Beratung | LIVAG AG',
    description: 'Haus oder Wohnung in der Ostschweiz verkaufen? LIVAG AG begleitet Sie von der Bewertung bis zum Abschluss. Jetzt kostenlos beraten lassen.',
    keywords: 'Immobilie verkaufen Ostschweiz, Haus verkaufen Schweiz, Hausverkauf St. Gallen',
    canonical: `${SITE}/immobilien-verkauf`,
  },
  immobilienKauf: {
    title: 'Immobilie kaufen Ostschweiz – Angebote & Beratung | LIVAG',
    description: 'Haus oder Wohnung in der Ostschweiz kaufen: LIVAG AG zeigt Ihnen passende Objekte und begleitet den Kaufprozess. Jetzt anfragen.',
    keywords: 'Immobilie kaufen Ostschweiz, Haus kaufen Schweiz, Wohnung kaufen St. Gallen',
    canonical: `${SITE}/immobilien-kauf`,
  },
  renditeobjektKaufen: {
    title: 'Renditeobjekt kaufen Ostschweiz – Objektanalyse | LIVAG AG',
    description: 'Renditeobjekte in der Ostschweiz kaufen: LIVAG AG unterstützt mit fundierter Objektanalyse und persönlicher Beratung. Jetzt anfragen.',
    keywords: 'Renditeobjekt kaufen, Renditeimmobilie Schweiz, Anlageobjekt Ostschweiz, Objektanalyse',
    canonical: `${SITE}/renditeobjekt-kaufen`,
  },
  renditeobjektVerkaufen: {
    title: 'Renditeobjekt verkaufen Ostschweiz – LIVAG AG',
    description: 'Renditeobjekt oder Anlageimmobilie verkaufen? LIVAG AG bewertet und vermarktet Ihr Objekt professionell. Jetzt kostenlos beraten lassen.',
    keywords: 'Renditeobjekt verkaufen, Anlageobjekt verkaufen, Mehrfamilienhaus verkaufen Ostschweiz',
    canonical: `${SITE}/renditeobjekt-verkaufen`,
  },
  privacy: {
    title: 'Datenschutzerklärung | LIVAG AG',
    description: 'Datenschutzerklärung der LIVAG AG zur Verarbeitung personenbezogener Daten auf livag.ch.',
    keywords: 'Datenschutz LIVAG',
    canonical: `${SITE}/datenschutz`,
  },
  impressum: {
    title: 'Impressum | LIVAG AG',
    description: 'Impressum und rechtliche Angaben der LIVAG AG, St. Gallen.',
    keywords: 'Impressum LIVAG',
    canonical: `${SITE}/impressum`,
  },
  sitemap: {
    title: 'Sitemap | LIVAG AG',
    description: 'Übersicht aller Seiten von livag.ch.',
    keywords: 'Sitemap LIVAG',
    canonical: `${SITE}/sitemap`,
  },
  notFound: {
    title: 'Seite nicht gefunden | LIVAG AG',
    description: 'Die gesuchte Seite wurde nicht gefunden.',
    keywords: 'LIVAG AG',
    canonical: `${SITE}/`,
  },
};

export const useSEO = (page) => {
  useEffect(() => {
    const config = seoConfig[page] || seoConfig.home;

    document.title = config.title;

    const set = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    set('meta[name="title"]', 'content', config.title);
    set('meta[name="description"]', 'content', config.description);
    set('meta[name="keywords"]', 'content', config.keywords || '');
    set('link[rel="canonical"]', 'href', config.canonical);
    set('meta[property="og:title"]', 'content', config.title);
    set('meta[property="og:description"]', 'content', config.description);
    set('meta[property="og:url"]', 'content', config.canonical);
    set('meta[name="twitter:title"]', 'content', config.title);
    set('meta[name="twitter:description"]', 'content', config.description);
    set('meta[name="twitter:url"]', 'content', config.canonical);
  }, [page]);
};

export const useDynamicSEO = ({ title, description, canonical, ogImage }) => {
  useEffect(() => {
    if (!title) return;

    document.title = title;
    const set = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el && value) el.setAttribute(attr, value);
    };

    set('meta[name="description"]', 'content', description);
    set('link[rel="canonical"]', 'href', canonical);
    set('meta[property="og:title"]', 'content', title);
    set('meta[property="og:description"]', 'content', description);
    set('meta[property="og:url"]', 'content', canonical);
    set('meta[name="twitter:title"]', 'content', title);
    set('meta[name="twitter:description"]', 'content', description);
    if (ogImage) set('meta[property="og:image"]', 'content', ogImage);
  }, [title, description, canonical, ogImage]);
};

export default useSEO;
